import { important } from 'csx';
import { TEAL_PRIMARY } from 'src/common-ui/theme';
import { style } from 'typestyle';

export const generalPopperHeight = 250;
export const FONT_FAMILY = "Open Sans";
const container = style({
  $debugName: 'autocomplete-container',
  position: 'relative',
  width: '100%',
  fontFamily: important(`${FONT_FAMILY}, Arial, sans-serif`),
  $nest: {
    '& .select-container.disabled': {
      cursor: 'not-allowed !important',
    },
    '.select-container': {
      position: 'relative',
      minWidth: '200px',
      width: '100%',
      maxWidth: '400px',
      backgroundColor: 'white',
    },
  },
});
export const generalPopupIndicator = style({
  $debugName: 'autocomplete-popper-general-indicator',
  transform: 'none !important',
  $nest: {
    '& > span:first-child': {
      borderLeft: '1px solid rgb(204, 204, 204) !important',
      paddingLeft: '6px',
    },
  },
});
export const generalPopper = style({
  $debugName: 'autocomplete-popper-general',
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 11px !important',
  maxHeight: generalPopperHeight,
});
export const customPopperStyle = style({
  $debugName: 'autocomplete-popper-fw',
  width: '100% !important',
});
export const autocompleteOptionStyles = style({
  $debugName: 'autocomplete-option',
  $nest: {
    '&:hover': {
      backgroundColor: TEAL_PRIMARY,
      color: 'white',
      opacity: '45%',
    },
    '&[aria-selected="true"]': {
      backgroundColor: `${TEAL_PRIMARY} !important`,
      color: 'white',
    },
  },
});
const errorIcon = style({
  color: 'darkred',
  fontSize: '1.2rem',
  padding: '5px',
});

export const autocompleteStyles = (
  multiSelect?: boolean,
  styleOverride?: React.CSSProperties,
  selectionCount?: number,
) => {
  return {
    root: style({
      $debugName: 'autocomplete-root',
      height: multiSelect ? styleOverride?.height : undefined,
      $nest: {
        '.Mui-focused .s5-MuiOutlinedInput-notchedOutline': {
          borderColor: `${TEAL_PRIMARY} !important`,
        },
      },
    }),
    option: style({
      $debugName: 'autocomplete-option',
      $nest: {
        '&[data-focus="true"]': {
          backgroundColor: 'rgb(222, 235, 255) !important',
        },
      },
    }),
    inputRoot: style({
      $debugName: 'autocomplete-input-root',
      minHeight: multiSelect ? 38 : undefined,
      height: multiSelect ? styleOverride?.height : undefined,
      // only applies when we have a single selection in the multiselect chip container
      display: multiSelect && selectionCount === 1 ? 'block !important' : undefined,
      $nest: {
        '&:disabled': {
          cursor: 'not-allowed !important',
        },
        '.s5-MuiInputBase-input': {
          fontSize: '0.9rem',
          padding: '4px !important',
        },
      },
    }),
    input: style({
      $debugName: 'autocomplete-input',
      // only applies when we have a single selection in the multiselect chip container
      width: multiSelect && selectionCount === 1 ? 'auto !important' : undefined,
      $nest: {
        '&:disabled': {
          cursor: 'not-allowed',
        },
      },
    }),
    endAdornment: style({
      $debugName: 'autocomplete-end-adorn',
      display: 'flex',
    }),
    tagSizeSmall: style({
      $debugName: 'autocomplete-tag-size',
      fontSize: 0.75,
    }),
  };
};

export function getChipStyles(options?: { fullWidth: boolean }) {
  const fullWidth = options ? options.fullWidth : false;
  return {
    root: style({
      $debugName: 'autocomplete-chip-root',
      borderRadius: '2px !important',
      fontFamily: important('"Open Sans", Arial, sans-serif'),
      height: 22,
      width: fullWidth ? '100%' : undefined,
    }),
    deleteIcon: style({
      $debugName: 'autocomplete-chip-delete',
      height: '100% !important',
      margin: '0 !important',
      $nest: {
        '&:hover': {
          backgroundColor: 'rgb(255, 189, 173)',
          color: 'rgb(222, 53, 11) ',
        },
      },
    }),
    label: style({
      width: fullWidth ? '100%' : undefined,
    }),
  };
}
export default {
  container,
  errorIcon,
};
